"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialTableRow = exports.MaterialTableRowUnstyled = void 0;
const router_1 = require("client/components/router");
const material_ui_1 = require("material-ui");
const Table_1 = require("material-ui/Table");
const react_1 = require("react");
const React = require("react");
const decorate = material_ui_1.withStyles(theme => ({
    root: {
        backgroundColor: "#fff",
        height: "50px"
    },
    header: {
        backgroundColor: "#e9ebf1",
        height: "45px",
        textTransform: "uppercase",
        width: "auto"
    },
    groupHeader: {
        backgroundColor: "#f1f3f8",
        height: "36px"
    }
}));
class MaterialTableRowUnstyled extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleClick = (e) => {
            const { onClick, to } = this.props;
            if (to) {
                router_1.RouteManager.transitionTo(to);
            }
            onClick && onClick(e);
        };
    }
    render() {
        const { children, classes, groupHeader, header } = this.props;
        return (React.createElement(Table_1.TableRow, { classes: {
                root: groupHeader
                    ? classes.groupHeader
                    : header
                        ? classes.header
                        : classes.root
            }, onClick: this.handleClick }, children));
    }
}
exports.MaterialTableRowUnstyled = MaterialTableRowUnstyled;
exports.MaterialTableRow = decorate(MaterialTableRowUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/table/table-row/table-row.tsx
// module id = 3271
// module chunks = 0